import React, { useState, useEffect } from 'react';
import '../../../App.css';
import { db, categories_col_name } from '../../../firebase';
import {
    collection,
    addDoc,
    serverTimestamp,
    query,
    where,
    getDocs,
    deleteDoc,
    doc
} from 'firebase/firestore';

const ManageCategories = () => {
    const [categoryName, setCategoryName] = useState('all');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [existingCategories, setExistingCategories] = useState([]);

    const fetchCategories = async () => {
        try {
            const q = query(collection(db, categories_col_name));
            const snapshot = await getDocs(q);
            const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
            setExistingCategories(list);
        } catch (err) {
            console.error('Error fetching categories:', err);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const trimmed = categoryName.trim();
        if (!trimmed) {
            setError('Please enter a category name.');
            return;
        }

        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const nameLower = trimmed.toLowerCase();
            const checkQuery = query(
                collection(db, categories_col_name),
                where('nameLower', '==', nameLower)
            );
            const existing = await getDocs(checkQuery);

            if (!existing.empty) {
                setError('This category already exists.');
                setLoading(false);
                return;
            }

            await addDoc(collection(db, categories_col_name), {
                name: trimmed,
                nameLower,
                createdAt: serverTimestamp()
            });

            setSuccess(true);
            setCategoryName('all');
            fetchCategories();
            setTimeout(() => setSuccess(false), 3000);
        } catch (err) {
            console.error('Error adding category:', err);
            setError('Failed to add category. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this category?')) return;
        try {
            await deleteDoc(doc(db, categories_col_name, id));
            fetchCategories();
        } catch (err) {
            console.error('Error deleting category:', err);
        }
    };

    return (
        <section className="admin-section fade-in">
            <h2>Add Categories</h2>
            <form className="admin-form" onSubmit={handleSubmit}>
                <div className="add-products-form-grid">
                    <div className="form-group">
                        <label>Category Name</label>
                        <input
                            type="text"
                            placeholder="e.g. abaya"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            maxLength={50}
                            required
                        />
                    </div>
                </div>
                <button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? 'Adding...' : 'Add Category'}
                </button>
            </form>

            {success && (
                <div
                    className="alert alert-success"
                    style={{
                        padding: '10px',
                        backgroundColor: '#d4edda',
                        color: '#155724',
                        marginTop: '15px',
                        marginBottom: '15px',
                        borderRadius: '4px'
                    }}
                >
                    Category added successfully!
                </div>
            )}

            {error && (
                <div
                    className="alert alert-danger"
                    style={{
                        padding: '10px',
                        backgroundColor: '#f8d7da',
                        color: '#721c24',
                        marginTop: '15px',
                        marginBottom: '15px',
                        borderRadius: '4px'
                    }}
                >
                    {error}
                </div>
            )}

            <div className="existing-items">
                <h3>Existing Categories</h3>
                <ul className="item-list">
                    {existingCategories.length === 0 ? (
                        <li>No categories yet.</li>
                    ) : (
                        existingCategories.map((cat) => (
                            <li key={cat.id}>
                                {cat.name}{' '}
                                <button
                                    type="button"
                                    className="btn-sm btn-delete"
                                    onClick={() => handleDelete(cat.id)}
                                >
                                    Delete
                                </button>
                            </li>
                        ))
                    )}
                </ul>
            </div>
        </section>
    );
};

export { ManageCategories };
